import SearchFilterAccordions from './SearchFilterAccordions';

export { type SearchFilterAccordionsProps } from './SearchFilterAccordions';
export default SearchFilterAccordions;
